import { useState } from 'react';
import ShipmentTimeline from './ShipmentTimeline';
import CoachReport from './CoachReport';
import MaterialPlanning from './MaterialPlanning';
import MdpScheduleGrid from './MdpScheduleGrid';


// City Bus Reports wrapper with sub-tabs
function CityBusReports({ onNavigateToPlanning }) {
  const [subTab, setSubTab] = useState('overview');
  const [hasSelectedProject, setHasSelectedProject] = useState(false);
  const tabs = [
    { id: 'overview', label: 'Production Overview' },
    { id: 'schedule', label: 'MDP Schedule' },
    { id: 'material', label: 'Material Planning' },
  ];
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-1 bg-slate-100 rounded-lg p-1 w-fit">
        {tabs.map(t => (
          <button key={t.id} onClick={() => setSubTab(t.id)}
            className={`px-4 py-2 rounded-md text-sm font-semibold transition-all ${subTab === t.id ? 'bg-white text-slate-800 shadow-sm' : 'text-slate-500 hover:text-slate-700'}`}
            data-testid={`citybus-tab-${t.id}`}>
            {t.label}
          </button>
        ))}
      </div>
      {subTab === 'overview' && (
        <>
          {!hasSelectedProject && <ShipmentTimeline />}
          <CoachReport
            category="City Bus"
            onNavigateToPlanning={onNavigateToPlanning}
            onProjectChange={(id) => setHasSelectedProject(!!id)}
          />
        </>
      )}
      {subTab === 'schedule' && <MdpScheduleGrid category="City Bus" />}
      <div style={{ display: subTab === 'material' ? 'block' : 'none' }}>
        <MaterialPlanning />
      </div>
    </div>
  );
}

export default CityBusReports;
